import React from "react"

const UploaderIndex = () => {
  return <></>
}

export default UploaderIndex
